import Accordion from '../lib/accordion';

const ceAccordion = () => {

  // select article within accorions for accoridon wrapper
  const accordions = [];
  const articleArray = document.querySelectorAll('.mod_article .inside');
  articleArray.forEach((article) => {
    if (article.querySelector('.ce_accordionStart') || article.querySelector('.ce_accordionSingle')) {
      accordions.push(article);
    }
  });


  accordions.forEach((wrapper) => {
    const accElements = wrapper.querySelectorAll('.ce_accordion');
    // Wrapper element last rule
    const accWrapperElements = wrapper.querySelectorAll('.ce_accordionStart');
    let lastElement = accWrapperElements[accWrapperElements.length - 1];
    lastElement.classList.add('last');

    // check toggle
    const openElements = [];
    for (var i = 0; i < accElements.length; i++) {
      const element = accElements[i];

      if(element.getAttribute('toggle') == 'open') {
        openElements.push(i);
      }
    }

    new Accordion(wrapper, {
      openOnInit: openElements
    });
  });

}

export default ceAccordion;
